import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import element from '@/plugins/element'
import GlobalComponentRegister from '@/plugins/register'
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/styles/index.scss'
import './styles.scss'
import '@/assets/font/iconfont.js'

import './axios'
import { inputBorder } from './directives'

import './components/register'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import * as api from './api'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'
const debugEnable =
  process.env.NODE_ENV !== 'production' || /^test/.test(location.hostname)

Vue.config.debug = debugEnable
Vue.config.devtools = debugEnable
Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.use(VueStorage, config.storageOptions)
Vue.use(element)
Vue.use(GlobalComponentRegister)
Vue.directive('input-border', inputBorder)
Vue.use(VueQuillEditor)
Vue.use(Viewer)

// 测试环境正常显示线上图片
if (process.env.NODE_ENV !== 'production') {
  window.addEventListener(
    'error',
    e => {
      const { tagName = '', src = '' } = e.target || {}
      if (!tagName) return
      if (!/\/storage/.test(src)) return
      if (
        tagName.toLowerCase() === 'img' &&
        src.includes(window.location.host)
      ) {
        const baseURL = process.env.VUE_APP_BASE_URL
        e.target.src = e.target.src.replace(
          /.+?(?=\/storage)/,
          baseURL
        )
      }
    },
    true
  )
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
